module.exports = __webpack_public_path__ + "img/official.c0e2cc75.png";